import { render, staticRenderFns } from "./StudentCurrentObjectiveEntrance.vue?vue&type=template&id=eb0bc2fc&scoped=true&lang=pug&"
import script from "./StudentCurrentObjectiveEntrance.vue?vue&type=script&lang=ts&"
export * from "./StudentCurrentObjectiveEntrance.vue?vue&type=script&lang=ts&"
import style0 from "./StudentCurrentObjectiveEntrance.vue?vue&type=style&index=0&id=eb0bc2fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0bc2fc",
  null
  
)

export default component.exports